import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";

import { EditorField, FormCollapsible, SubmitButton } from "components/forms";
import * as notifications from "notifications";
import { createCaseFromFiles, selectAccountCaseHierarchy, selectAccountHierarchy } from "actions";
import { Form } from "react-bootstrap";
import MultipleFileDropZone from "../../../components/MultipleFileDropZone";
import WSelect from "../../../components/forms/selects/WindowedSelect";
import { activeAccountIdSelector, managementChoicesSelector } from "../../../reducers";
import CreateFromFilesHierarchyTable from "./CreateFromFilesHierarchyTable";

const CaseCreateFromFilesForm = ({ ...props }) => {
  const navigate = useNavigate();
  const [accountId, setAccountId] = React.useState(null);
  const [files, setFiles] = React.useState([]);

  const handleAccountChange = option => {
    // Request the Account every time the dropdown changes
    if (option) {
      props.selectAccountCaseHierarchy(option.value);
      setAccountId(option.value);
    } else {
      setAccountId(null);
    }
  };

  return (
    <Formik
      enableReinitialize={false}
      initialValues={{
        account_id: accountId,
      }}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          values.account_id = accountId;
          values.files = files;
          await props.createCaseFromFiles(values, navigate);
        } catch (error) {
          notifications.error(`Error occurred: ${error}`);
        }
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        const setFilesCallback = fileList => {
          setFiles(fileList);
        };

        return (
          <>
            <FormCollapsible onSubmit={handleSubmit} title={"New Case From Files"}>
              <Form.Row>
                <WSelect
                  label="Select Account"
                  name="account_id"
                  options={props.accountChoices}
                  onChange={handleAccountChange}
                  placeholder="Select Account"
                  required={true}
                />
              </Form.Row>
              <Form.Row style={{ margin: "0 5px" }}>
                <CreateFromFilesHierarchyTable />
              </Form.Row>
              <Form.Row>
                <EditorField style={{ width: "100%" }} inline={false} label="Notes" name="notes" autoFocus={false} />
              </Form.Row>
              <br />
              <Form.Row>
                <MultipleFileDropZone
                  setFieldValue={setFieldValue}
                  setFilesCallback={setFilesCallback}
                  message={
                    <>
                      Drag and drop or click to select files
                      <br />
                      Images and Word documents will be converted to PDF
                    </>
                  }
                  accept={
                    "application/pdf,image/jpeg,image/png,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  }
                />
              </Form.Row>
              <SubmitButton defaultText={"Create Case Draft"} disabled={files.length === 0} />
            </FormCollapsible>
          </>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);
  return {
    accountChoices: choices.accounts?.getChoices({ sortByLabel: true }) || [],
    activeAccountId: activeAccountIdSelector(state),
  };
};

export default connect(mapStateToProps, {
  createCaseFromFiles,
  selectAccountCaseHierarchy,
  selectAccountHierarchy,
})(CaseCreateFromFilesForm);
